import { AuthApi } from "@/api/auth";
import { VerifyResetPasswordRequest } from "@/api/auth/types";
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";

export const useVerifyResetCode = () => {
  const { mutate, isPending: isVerifyResetCodeLoading } = useMutation({
    mutationFn: (body: VerifyResetPasswordRequest) => AuthApi.verifyResetPasswordCode(body),
    onSuccess: () => {
      toast.success("Code verified successfully!");
      // No navigation needed as we're handling step changes internally
    },
    onError: (error) => {
      toast.error(error);
    },
  });

  // Wrap the mutate function to accept an onSuccess callback
  const verifyResetCode = (body: VerifyResetPasswordRequest, onSuccess?: () => void) => {
    mutate(body, {
      onSuccess: () => {
        if (onSuccess) {
          onSuccess();
        }
      }
    });
  };

  return { verifyResetCode, isVerifyResetCodeLoading };
};
